import React from "react";

import { Typography } from "@packages/ds";
import { useIntl, FormattedMessage } from "react-intl";

import config from "console_config";
import { Link, ButtonWrapper } from "ds/Button";
import useUrls from "Hooks/useUrls";
import getUrl from "Libs/getUrl";
import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import type { Project } from "@packages/client";

type ErrorContentProps = {
  organizationId: string;
  projectId: string;
  environmentId: string;
  subscriptionId?: string;
  canEditPlan?: boolean;
  project?: Project;
};
const ErrorContent = ({
  organizationId,
  projectId,
  environmentId,
  subscriptionId,
  canEditPlan,
  project
}: ErrorContentProps) => {
  const intl = useIntl();
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);

  const [environmentUrl] = useUrls("organization.project.environment", {
    organizationId,
    projectId,
    environmentId
  });

  let billingURL: string | undefined;

  const i18nPrefix = canEditPlan ? "admin" : "standard";
  const CUSTOM_URL_SUBSCRIPTION_UPGRADE =
    config.CUSTOM_URL_SUBSCRIPTION_UPGRADE;

  if (organizationEnabled) {
    billingURL =
      subscriptionId &&
      getUrl({
        key: "organization.billing.plan.subscription",
        props: { organizationId, subscriptionId }
      });
  }

  if (
    CUSTOM_URL_SUBSCRIPTION_UPGRADE &&
    typeof CUSTOM_URL_SUBSCRIPTION_UPGRADE === "string" &&
    CUSTOM_URL_SUBSCRIPTION_UPGRADE.indexOf(":projectId") !== -1
  ) {
    billingURL = CUSTOM_URL_SUBSCRIPTION_UPGRADE.replace(
      ":projectId",
      projectId
    );
  } else if (CUSTOM_URL_SUBSCRIPTION_UPGRADE && project?.plan_uri) {
    billingURL = project?.plan_uri;
  }

  return (
    <>
      <Typography.Title tag="h3">
        {intl.formatMessage({ id: "environment.branch.error.title" })}
      </Typography.Title>
      <Typography.BodyText>
        {intl.formatMessage({
          id: `environment.branch.error.${i18nPrefix}.description`
        })}
      </Typography.BodyText>

      <ButtonWrapper spacing="modal" justifyContent="end">
        {canEditPlan && billingURL ? (
          <>
            <Link variant="secondary" to={environmentUrl} analyticId="cancel">
              <FormattedMessage id="cancel" />
            </Link>
            <Link
              variant="primary"
              to={billingURL}
              analyticId="project.plan.upgrade"
              target={
                config.CUSTOM_URL_SUBSCRIPTION_UPGRADE ? "_blank" : undefined
              }
            >
              <FormattedMessage id="project.plan.upgrade" />
            </Link>
          </>
        ) : (
          <Link variant="primary" to={environmentUrl} analyticId="okay">
            <FormattedMessage id="okay" />
          </Link>
        )}
      </ButtonWrapper>
    </>
  );
};

export default ErrorContent;
